import request from "@/utils/request";
import { getRequest } from "@/utils/postData";
import { timers } from "jquery";
// 获取广告信息
export function getone(id, keywords = "") {
  let frequency_control_id =
    localStorage.getItem("uuidv4") || "fa37bade-b32d-4ef2-a132-91064444662b";

  let localAddCode = localStorage.getItem("address_code");
  let areaId = "";
  if (localAddCode && localAddCode !== "undefined") {
    areaId = localAddCode;
  } else {
    areaId = "4201";
  }
  return request({
    url: "/v_adv/search",
    method: "get",
    params: {
      id: id,
      keywords: keywords,
      frequency_control_id: frequency_control_id,
      areaId: areaId
    }
  });
}

//点击跳转广告埋点
// 获取地区信息
// export function advclick(param,adsploc='home',adaca2='',adaid='') {
//     var userId = '';
//     var userInfo = localStorage.getItem("userInfo");
//     if(userInfo){
//         userInfo = JSON.parse(userInfo);
//         userId = userInfo.id;
//     }
//     return request({
//         url: '/v_adv_gif/ad.gif',
//         method: 'get',
//         params: {
//             eca: 'clk',
//             eac: 'ad',
//             cid: userId,
//             dtt: 1,
//             dtn: 74,
//             amn: 85,
//             ruid: userId,
//             ud_adspace: param.adslot_id,
//             ud_adsname: param.adslot_name,
//             ud_adstype: param.adslot_type,
//             ud_adsploc: adsploc,
//             ud_adaca2: adaca2,//adsploc= article时必填：magazine+[杂志id]、subject +[单行本id]、theme +[专题id]、topic +[标签id]
//             ud_adaid: adaid,  //adsploc= article时必填：取文章id
//             ud_adsold: param.creative_id ? 1 : 0,
//             ud_adsource: param.creative_id,
//             ud_adsoname: param.creative_name,
//             ud_adtemp: param.template_id,
//             ud_adtname: param.template_name,
//             ud_advtser: param.publisher_id,
//             ud_adorder: param.order_id,
//             ud_adcontrol: param.adslot_id,
//             v: new Date()
//         }
//     })
// }
export function advclick(param, adsploc = "home", adaca2 = "", adaid = "") {
  var userId = "";
  var userInfo = localStorage.getItem("userInfo");
  if (userInfo) {
    userInfo = JSON.parse(userInfo);
    userId = userInfo.id;
  }
  return request({
    url: "/v_adv_gif/ad.gif",
    method: "get",
    params: {
      eca: "clk",
      eac: "ad",
      cid: userId,
      dtt: 1,
      dtn: 74,
      amn: 85,
      ruid: userId,
      adspace: param.adslot_id,
      adsname: param.adslot_name,
      adstype: param.adslot_type,
      adsploc: adsploc,
      adaca2: adaca2, //adsploc= article时必填：magazine+[杂志id]、subject +[单行本id]、theme +[专题id]、topic +[标签id]
      adaid: adaid, //adsploc= article时必填：取文章id
      adsold: param.creative_id ? 1 : 0,
      adsource: param.creative_id,
      adsoname: param.creative_name,
      adtemp: param.template_id,
      adtname: param.template_name,
      advtser: param.publisher_id,
      adorder: param.order_id,
      adcontrol: param.control_percent
    }
  });
}

// 获取地区信息
export function getaddress() {
  return request({
    url: "/v_address/ip.jsp",
    method: "get"
  });
}



// WEBPACK FOOTER //
// ./src/api/adv.js